import { Button } from '@fabric-ds/react';
import SidebarContext from 'state/SidebarContext';
import { useContext, useState } from 'react';
import VippsLogo from 'resources/icons/VippsLogo';
import pulseClient from 'resources/pulse';

const PaymentSection = () => {
    const { uiText, finnkode, isOwnAd, isExperiment } = useContext(SidebarContext);

    const { actions, paymentText } = uiText.sections.sidebar.optedIn;
    const [ownAdErrosMsg, setOwnAdErrorMsg] = useState(false);

    const handleClick = () => {
        if (isOwnAd === 'true') {
            setOwnAdErrorMsg(true);
        } else {
            pulseClient.trackCreateOfferClick(finnkode);
            window.location.href = `/bap/kjop/ny?finnkode=${finnkode}`;
        }
    };

    return (
        <div className="flex flex-col-reverse md:flex-col">
            <div>
                <Button className="w-full max-w-full" primary onClick={handleClick}>
                    {isExperiment ? 'Kjøp med Fiks ferdig' : actions.initTransaction.text}
                </Button>
                {ownAdErrosMsg && (
                    <p className="text-red-500 text-center my-4 text-12">
                        Oi sann! Du kan ikke kjøpe din egen vare.
                    </p>
                )}
            </div>
            <span className="flex items-center space-x-4 md:mt-8 mb-24 md:mb-0">
                <p className="m-0 text-14">{paymentText}</p>
                <VippsLogo />
            </span>
        </div>
    );
};

export default PaymentSection;
